@if (!editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-2">
      <div class="tw:w-full tw:px-[15px] tw:mb-0">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k tw:py-1">Time Slot:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v tw:py-1">{{ timelineSection.startTime }} - {{ timelineSection.endTime }} &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k tw:py-1">Session Type:</div>
            <div class="kvp__k tw:py-1">Session Delivery:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v tw:py-1">{{ timelineSection.sessionType }} &nbsp;</div>
            <div class="kvp__v tw:py-1">{{ timelineSection.sessionDelivery }} &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-12">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
          <div class="tw:w-auto tw:px-[15px]">
            <div class="kvp__k tw:py-1">Subject:</div>
            <div class="kvp__k tw:py-1">Attendance:</div>
          </div>
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp__v tw:py-1">{{ timelineSection.subject }} &nbsp;</div>
            <div class="kvp__v tw:py-1">{{ timelineSection.attendance }} &nbsp;</div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px]">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Learning Objective 1:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.learningObjective1 }}
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Learning Objective 2:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.learningObjective2 }}
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Learning Objective 3:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.learningObjective3 }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tw:w-full tw:px-[15px]">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Engagement:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.engagementComment }}
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
          <div class="tw:flex-1 tw:px-[15px]">
            <div class="kvp kvp--stacked">
              <div class="kvp__k kvp__k--heading">Learning comment:</div>
              <div class="kvp__v kvp__v--long-text">
                {{ timelineSection.learningComment }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
